import React, { Component } from 'react'
import styles from './SimpleModal.module.css'

/**
 * @typedef {Object} SimpleModalProps
 * @property {boolean} isOpen
 * @property {string} title 
 * @property {() => void} onClose 
 */

/**
 * @extends {React.Component<SimpleModalProps>}
 */
class SimpleModal extends Component {
	render() {
		let modalContainerClass = styles.modalContainer
		if (this.props.isOpen) {
			modalContainerClass += " " + styles.modalContainerOpen
		}

        return (
            <div className={modalContainerClass}>
				<div className={styles.modalOverlay}></div>
				<div className={`${styles.modalBox} bg-white w-1/2 z-10 rounded-sm p-8`}>
					<div className='flex justify-between items-center mb-5'>
						<h2 className='font-medium text-2xl'>{this.props.title}</h2>
						<button className='text-3xl' onClick={this.props.onClose}>&times;</button>
					</div>
					<div>{this.props.children}</div>
				</div>
			</div>
        )
    }
}

export default SimpleModal